<template>
  <div class="column is-half is-offset-one-quarter">
    <div class="card">
      <div class="has-text-centered is-padding-top has-bg-white">
        <router-link :to="{name: 'Home'}">
          <img :src="$configs.LOGO_LOGIN" width="154" alt="LOGO">
        </router-link>
      </div>
      <header class="card-header is-light is-border-bottom">
        <h1 class="card-header-title is-size-4">
          <!-- <span class="picto">
            <span class="is-border">
              <i class="fal fa-life-ring"></i>
            </span>
          </span> -->
          {{title}}
        </h1>
      </header>
      <section class="card-content">
        <div class="">
          <p v-if="text">{{text}}</p>
          <form @submit.prevent.stop="submit">
            <div v-if="step === STEPS.EMAIL_FORM">
              <p>
                Vous avez oublié votre mot de passe ?<br>
                Saisissez votre adresse e-mail et nous vous enverrons un lien de création de nouveau mot de passe.
              </p>
              <div class="control is-margin-top-small">
                <v-input id="resetEmail" name="resetEmail" @input="val => email = val" :model="email"
                         label="Email *" placeholder="Entrez votre email"
                         v-validate="'required|email'" :errors-bag="errors" data-vv-value-path="val"
                         data-vv-as="Email">
                </v-input>
              </div>
            </div>
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
              <div class="fastAnimation" v-if="step === STEPS.RESET_METHODS">
                <p>Nous avons trouvé les informations suivantes relatives à votre compte.</p>
                <div class="field is-margin-top-small">
                  <input id="email-method" v-model="resetMethod" name="method" type="radio" value="email"
                         class="is-checkradio">
                  <label for="email-method">
                    Envoyer un lien par email à <b>{{email}}</b>
                  </label>
                </div>
                <div v-for="(method, idx) in resetMethods" class="field" :key="idx">
                  <input :id="'phone-' + idx" v-model="resetMethod" name="method" type="radio" :value="method.value"
                         class="is-checkradio">
                  <label :for="'phone-' + idx">
                    Envoyer un code par SMS à mon numéro de téléphone se terminant par
                    <b>{{method.label}}</b>
                  </label>
                </div>
              </div>
              <div class="fastAnimation" v-if="step === STEPS.TOKEN_FORM">
                <p>Nous avons envoyé un code par SMS sur votre numéro de téléphone. <br>
                  Une fois le code reçu, entrez le ci-dessous pour réinitialiser votre mot de passe.</p>
                <v-input id="token" name="token" @input="val => token = val"
                         :model="token"
                         label="Code *"
                         v-validate="'required|min:6'" :errors-bag="errors" data-vv-value-path="val"
                         data-vv-as="Code">
                </v-input>
                <p><a @click.prevent.stop="resendToken">Je n'ai pas reçu le SMS ? Envoyez un email</a></p>
              </div>
              <div class="columns fastAnimation" v-if="step === STEPS.PASSWORD_FORM">
                <div class="column is-paddingless-left">
                  <div class="field">
                    <div class="control has-icons-right">
                      <v-input id="password1" name="password" @input="val => password = val"
                               :model="password" :input-type="displayPassword1 ? 'text' : 'password'"
                               label="Mot de passe *"
                               v-validate="'required|min:6'" :errors-bag="errors" data-vv-value-path="val"
                               data-vv-as="Mot de passe" :icon="' '">
                        <p class="control">
                          <a class="button is-square is-radiusless" @click="displayPassword1 = !displayPassword1">
                            <i class="fal" :class="!displayPassword1 ? 'fa-eye' : 'fa-eye-slash'"></i>
                          </a>
                        </p>
                      </v-input>
                    </div>
                  </div>
                </div>
                <div class="column is-paddingless-right">
                  <div class="field">
                    <div class="control has-icons-right">
                      <v-input id="password2" name="confirmPassword"
                               @input="val => confirmPassword = val"
                               :model="confirmPassword" :input-type="displayPassword2 ? 'text' : 'password'"
                               label="Confirmation du mot de passe *"
                               v-validate="'required|min:6'" :errors-bag="errors" data-vv-value-path="val"
                               data-vv-as="Confirmation du mot de passe" :icon="' '">
                        <p class="control">
                          <a class="button is-square is-radiusless" @click="displayPassword2 = !displayPassword2">
                            <i class="fal" :class="!displayPassword2 ? 'fa-eye' : 'fa-eye-slash'"></i>
                          </a>
                        </p>
                      </v-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="fastAnimation" v-if="step === STEPS.MAIL_SENT">
                <div class="columns is-vcentered">
                  <div class="column">
                    <p class="has-text-centered">
                      Les instructions de réinitialisation de votre mot de passe ont été
                      envoyées à <b>{{email}}</b>.
                    </p>
                    <p class="has-text-centered">
                      Vous recevrez cet e-mail dans les cinq minutes. Vérifier votre dossier
                      de courrier
                      indésirable.</p>
                  </div>
                </div>
              </div>
              <div class="fastAnimation" v-if="step === STEPS.PASSWORD_SET">
                <div>Mot de passe actualisé, vous pouvez vous connecter.</div>
              </div>
              <div class="fastAnimation" v-if="step === STEPS.ERROR_MESSAGE">
                <div>Impossible de modifier votre mot de passe. Veuillez contactez un administrateur.</div>
              </div>
            </transition>
            <div class="control is-margin-top" v-if="step !== STEPS.MAIL_SENT">
              <button class="button is-success is-padding-left-large is-padding-right-large" @click.prevent.stop="submit" :disabled="!canSubmit"><span class="is-margin-left is-margin-right">Valider</span></button>
            </div>
            <div class="control is-margin-top" v-else>
              <router-link :to="{name: 'Login'}" class="button is-light"><span class="is-margin-left is-margin-right">Retour page login</span></router-link>
            </div>
          </form>
        </div>
      </section>

      <div class="is-padding-left is-padding-right">
        <div class="columns is-gapless is-align-items-flex-end">
          <div class="column is-7">
            <img src="static/logo-vadimm--x2.png" width="60" alt="">
          </div>
          <div class="column is-margin-bottom-xsmall">
            <p class="has-text-right has-text-grey is-size-7">
              <small>V. {{appVersion}}</small>
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { Error } from '@/mixins'
  import { bus, EVENTS } from '@/services/bus/index.js'

  const STEPS = Object.freeze({
    EMAIL_FORM: 'EMAIL_FORM',
    TOKEN_FORM: 'TOKEN_FORM',
    RESET_METHODS: 'RESET_METHODS',
    PASSWORD_FORM: 'PASSWORD_FORM',
    MAIL_SENT: 'MAIL_SENT',
    PASSWORD_SET: 'PASSWORD_SET',
    ERROR_MESSAGE: 'ERROR_MESSAGE'
  })

  export default {
    name: 'ResetPassword',
    mixins: [Error],
    data () {
      return {
        step: STEPS.EMAIL_FORM,
        STEPS: STEPS,
        email: null,
        resetMethods: [],
        resetMethod: null,
        title: 'Réinitialisation du mot de passe',
        text: null,
        token: null,
        password: null,
        confirmPassword: null,
        displayPassword1: false,
        displayPassword2: false
      }
    },
    computed: {
      appVersion () {
        return process.env.npm_package_version
      },
      samePassword () {
        return this.password && this.password === this.confirmPassword
      },
      canSubmit () {
        if (this.step === STEPS.EMAIL_FORM) {
          return this.email !== null && this.errors.any() === false
        } else if (this.step === STEPS.RESET_METHODS) {
          return this.resetMethod !== null
        } else if (this.step === STEPS.TOKEN_FORM) {
          return this.token !== null && this.errors.any() === false
        } else if (this.step === STEPS.PASSWORD_FORM) {
          return this.errors.any() === false
        }
        return false
      }
    },
    methods: {
      resendToken () {
        this.sendResetPasswordEmail()
        this.step = STEPS.MAIL_SENT
      },
      loadResetMethods () {
        this.$api.userService.resetMethods({email: this.email})
          .then(res => {
            this.title = 'Comment voulez-vous réinitialiser votre mot de passe ?'
            this.text = null
            if (!res.data.phone && !res.data.mobile) {
              this.sendResetPasswordEmail()
              this.step = STEPS.MAIL_SENT
              this.title = 'Instructions envoyées !'
            } else {
              if (res.data.phone) {
                this.resetMethods.push(res.data.phone)
              }
              this.step = STEPS.RESET_METHODS
            }
          })
          .catch(res => {
            this.handleError(res)
          })
      },
      sendResetPasswordEmail () {
        this.$api.userService.askToken({email: this.email}, this.$configs.APPHOST)
          .then(() => {
            this.$notify({
              type: 'is-success',
              text: 'Un email vous a été envoyé.'
            })
          })
          .catch(() => {
            this.$notify({
              type: 'is-danger',
              text: 'Email non reconnu, veuillez vérifier votre saisie.'
            })
          })
      },
      checkToken () {
        this.$api.userService.checkToken({token: this.token})
          .then(res => {
            this.title = 'Saisissez votre nouveau mot de passe'
            this.text = null
            this.step = STEPS.PASSWORD_FORM
          })
          .catch(() => {
            this.$notify({
              type: 'is-danger',
              text: 'Ce Code ne semble pas correct.'
            })
          })
      },
      sendResetTokenSms () {
        this.$api.userService.askToken({
          email: this.email,
          phone: this.resetMethod
        }, this.$configs.APPHOST)
          .then(() => {
            this.title = 'Saisissez le code reçu par sms'
            this.text = null
            this.$notify({
              type: 'is-success',
              text: 'Un sms vous a été envoyé.'
            })
          })
          .catch((err) => {
            this.handleError(err)
          })
      },
      resetPassword () {
        if (!this.samePassword) {
          this.$notify({
            type: 'is-danger',
            text: 'Les deux mots de passe ne sont pas identiques.'
          })
          return
        }
        let data = {
          token: this.token,
          password: this.password
        }
        this.$api.userService.resetPassword(data, this.$configs.APPHOST)
          .then((r) => {
            this.step = STEPS.PASSWORD_SET
            this.$notify({
              type: 'is-success',
              text: 'Mot de passe mis à jour avec succès.'
            })
            this.$router.replace({name: 'Login', force: true, query: {email: this.email}})
          })
          .catch(() => {
            this.$notify({
              type: 'is-danger',
              text: 'Erreur lors de la mise à jour de votre mot de passe. Veuillez vérifiez le formulaire.'
            })
          })
      },
      submit () {
        if (this.step === STEPS.EMAIL_FORM) {
          this.errors.clear()
          this.loadResetMethods()
        } else if (this.step === STEPS.RESET_METHODS) {
          if (this.resetMethod === 'email') {
            this.sendResetPasswordEmail()
            this.step = STEPS.MAIL_SENT
            this.title = 'Instructions envoyées !'
            this.text = null
          } else {
            this.sendResetTokenSms()
            this.errors.clear()
            this.step = STEPS.TOKEN_FORM
          }
        } else if (this.step === STEPS.TOKEN_FORM) {
          this.errors.clear()
          this.checkToken()
        } else if (this.step === STEPS.PASSWORD_FORM) {
          this.resetPassword()
        }
      }
    },
    created () {
      bus.$emit(EVENTS.LOGOUT)
      this.$store.commit('logout')
      this.$store.commit('initState')
      localStorage.removeItem('token')
      if (this.$route.query.token && this.$route.query.email) {
        this.email = this.$route.query.email
        this.token = this.$route.query.token
        this.step = STEPS.PASSWORD_FORM
      }
      if (this.$route.query.mode && this.$route.query.mode === 'invitation') {
        this.title = 'Activation compte utilisateur'
        this.text = 'Pour finaliser la création de votre compte utilisateur, merci de choisir un mot de passe de connexion.\nVotre mot de passe est confidentiel et sécurisé.'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login/ResetPassword.vue